import { render, staticRenderFns } from "./selectPopup.vue?vue&type=template&id=c8bb974a&scoped=true&"
import script from "./selectPopup.vue?vue&type=script&lang=js&"
export * from "./selectPopup.vue?vue&type=script&lang=js&"
import style0 from "./selectPopup.vue?vue&type=style&index=0&id=c8bb974a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bb974a",
  null
  
)

export default component.exports